import axios from "axios";
import { OliviaCrmAppApiUrl } from "../helpers/apiUrls";

export default axios.create({
    withCredentials: true,
    baseURL: OliviaCrmAppApiUrl,
});

export const axiosPrivate = axios.create({
    withCredentials: true,
    baseURL: OliviaCrmAppApiUrl,
});
